<svg (mouseenter)="mouseEnter()"
     (mouseleave)="mouseLeave()"
     [attr.height]="height"
     [attr.width]="width"
     [class.cursor-pointer]="isButton"
     fill="none"
     viewBox="0 0 160 160"
     xmlns="http://www.w3.org/2000/svg"
>
  <rect [attr.stroke]="color" fill="white"
        height="159"
        rx="79.5"
        width="159"
        x="0.5"
        y="0.5"/>
  <path
    [attr.fill]="userColor"
    d="M101.585 88.224C93.5603 86.3713 86.089 84.7473 89.708 77.9153C100.719 57.1207 92.627 46 81 46C69.142 46 61.2483 57.5477 72.292 77.9153C76.0207 84.787 68.267 86.411 60.4153 88.224C53.4643 89.8293 53 93.2243 53 99.1043L53.0117 102H57.6667C57.6667 94.6873 57.375 93.7167 61.9553 92.6597C68.6077 91.1267 74.889 89.6777 77.1803 84.5957C78.018 82.7407 78.5617 79.6887 76.3917 75.694C71.5897 66.8297 70.3763 59.153 73.0713 54.6333C76.2307 49.325 85.732 49.3507 88.861 54.554C91.5443 59.013 90.352 66.7317 85.5873 75.7313C83.464 79.7423 84.0217 82.785 84.864 84.6307C87.174 89.687 93.5137 91.15 100.227 92.6993C104.611 93.7167 104.333 94.7573 104.333 102H108.988L109 99.1043C109 93.2243 108.536 89.8293 101.585 88.224Z"/>
  <circle [attr.fill]="userColor" cx="100" cy="97"
          r="12"/>
  <path d="M99 92H101V102H99V92Z" fill="white"/>
  <path d="M105 96V98L95 98L95 96L105 96Z" fill="white"/>
</svg>